import { youkuClientId, youtubeModestBranding } from '../constants';
var YoutubeProvider = (function () {
    function YoutubeProvider() {
    }
    YoutubeProvider.prototype.create = function (id, elementId, options) {
        if (options === void 0) { options = {}; }
        var element = document.getElementById(elementId);
        if (!element) {
            return;
        }
        var iframe = document.createElement('iframe');
        var allow = [];
        var videoSrc = "//youtube.com/embed/" + id;
        element.appendChild(iframe);
        iframe.src = 'about:blank';
        videoSrc += "?showinfo=" + Number(!!options.showInfo) + "&rel=0&origin=" + encodeURIComponent(location.origin);
        videoSrc += "&modestbranding=" + youtubeModestBranding + "&hl=" + options.interfaceLanguage;
        iframe.frameBorder = '0';
        if (options.autoPlay) {
            allow.push('autoplay');
            videoSrc += "&autoplay=" + Number(Boolean(options.autoPlay));
        }
        if (options.allowFullscreen) {
            iframe.setAttribute('allowFullscreen', '1');
        }
        iframe.setAttribute('type', 'text/html');
        if (allow.length > 0) {
            iframe.allow = allow.join('; ');
        }
        if (options.lazy) {
            iframe.dataset.src = videoSrc;
        }
        else {
            iframe.src = videoSrc;
        }
    };
    return YoutubeProvider;
}());
export { YoutubeProvider };
var Ku6VideoProvider = (function () {
    function Ku6VideoProvider() {
    }
    Ku6VideoProvider.prototype.create = function (id, elementId, options) {
        var element = document.getElementById(elementId);
        if (!element) {
            return;
        }
        var iframe = document.createElement('iframe');
        var videoSrc = "//player.ku6.com/refer/" + id + "/v.swf&amp;adss=0";
        if (typeof options !== 'object' || options === null) {
            options = {};
        }
        if (options.lazy) {
            iframe.dataset.src = videoSrc;
        }
        else {
            iframe.src = videoSrc;
        }
        element.appendChild(iframe);
    };
    return Ku6VideoProvider;
}());
export { Ku6VideoProvider };
var YoukuVideoProvider = (function () {
    function YoukuVideoProvider() {
    }
    YoukuVideoProvider.prototype.create = function (id, elementId, options) {
        if (options === void 0) { options = {}; }
        var element = document.getElementById(elementId);
        if (!element) {
            return;
        }
        var iframe = document.createElement('iframe');
        var videoSrc = "//player.youku.com/embed/" + id + "?client_id=" + youkuClientId + "&password=&show_related=false";
        if (options.autoPlay) {
            videoSrc += '&autoplay=true';
            iframe.allow = 'autoplay';
        }
        iframe.frameBorder = '0';
        iframe.allowFullscreen = true;
        iframe.scrolling = 'no';
        iframe.setAttribute('ref', 'video');
        iframe.setAttribute('type', 'text/html');
        if (options.lazy) {
            iframe.dataset.src = videoSrc;
        }
        else {
            iframe.src = videoSrc;
        }
        element.appendChild(iframe);
    };
    return YoukuVideoProvider;
}());
export { YoukuVideoProvider };
